const contactEfforts = {
  addCallLog(controlIdNumber) {
    return `/contact-efforts/case/${controlIdNumber}`;
  },
  updateCallLog(contactEffortId, controlIdNumber) {
    return `/contact-efforts/${contactEffortId}/case/${controlIdNumber}`;
  },
  deleteCallLog(contactEffortId, controlIdNumber) {
    return `/contact-efforts/${contactEffortId}/case/${controlIdNumber}`;
  },
  getCallLog(contactEffortId, controlIdNumber) {
    return `/contact-efforts/${contactEffortId}/case/${controlIdNumber}`;
  },
  updateCallDueDate(controlIdNumber) {
    return `/contact-efforts/case/${controlIdNumber}/contact-due-date`;
  },  
  getCallLogSettings(controlIdNumber) {
    return `/contact-efforts/case/settings/${controlIdNumber}`;
  },  
  getCallLogContacts(controlIdNumber) {
    return `/contact-efforts/case/contacts/${controlIdNumber}`;
  },    
};

export default contactEfforts;